// Committees the user follows (★), kept in localStorage and shared by the committee pages
const FAVORITES_KEY = 'politikal_fav_committees';

export const loadFavoriteCommittees = (): Set<string> => {
  try {
    const raw = localStorage.getItem(FAVORITES_KEY);
    return raw ? new Set<string>(JSON.parse(raw)) : new Set<string>();
  } catch { return new Set<string>(); }
};

export const saveFavoriteCommittees = (favs: Set<string>) => {
  try { localStorage.setItem(FAVORITES_KEY, JSON.stringify(Array.from(favs))); } catch { /* ok */ }
};
